import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import { Media as ConfigMedia } from "config/media"
import Document from "components/Document"
import MediaItem from "components/MediaItem"
import PressKit from "components/PressKit"
import Navbar from "components/Navbar"
import { GetStartedType } from "components/Navbar/GetStartedButton"
import SideNav from "components/SideNav"
import Footer from "components/Footer"
import { brand } from "config/brand"
import PageWrapper, { PaddingTop } from "components/PageWrapper"
import LinkUnderline from "components/LinkUnderline"
import SubNavbarAbout from "components/SubNavbarAbout"

export interface MediaProps {
  raw?: boolean
}

const Media: React.FC<MediaProps> = ({ raw }) => {
  return (
    <Document
      title="Media"
      description={`Read the latest press coverage about how ${brand.name} is making buying and refinancing a home better for all Americans.`}
      pageId="MediaPage"
      pageClass="MediaPage AboutUsPage"
    >
      <Navbar getStartedType={GetStartedType.ALWAYS} />
      <SubNavbarAbout />
      <SideNav />
      <PageWrapper paddingTop={PaddingTop.SubNavbar}>
        <main
          className={cx({
            [styles.media]: true,
            [styles.mediaList]: true,
          })}
        >
          <div className={styles.pagePadding}>
            <div className={styles.header}>
              <h3 className={styles.heading}>In the news</h3>
              <h3 className={styles.subhead}>
                All media inquiries should be directed to our Head of Public
                Relations, Tanya Hayre, at{" "}
                <a className={styles.link} href="mailto:thayre@better.com">
                  <LinkUnderline>thayre@better.com</LinkUnderline>
                </a>
                .
              </h3>
            </div>
            <aside className={styles.pressKit}>
              <PressKit />
            </aside>
            <div className={styles.listWrapper}>
              <ul className={styles.list}>
                {ConfigMedia.map((item, index) => (
                  <li className={styles.item} key={index}>
                    {index === 0 && <MediaItem media={item} type="solid" />}
                    {index !== 0 && <MediaItem media={item} type="border" />}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </main>
        {!raw && <Footer />}
      </PageWrapper>
    </Document>
  )
}

export default Media
